import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild
} from '@angular/core';
import { ElementFocus } from '../../../models';
import {
  ButtonRoleType,
  ButtonSize,
  ButtonType,
  ElementType
} from '../../../types/button.types';
import { AtomButton } from './models/button.interface';

@Component({
  selector: 'idp-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnChanges, AtomButton {
  @ViewChild('idpButton') idpButton!: ElementRef;

  @Input() ariaLabel = '';
  @Input() ariaExpand: boolean | undefined;
  @Input() ariaPopup = false;
  @Input() bottomSpace = false;
  @Input() customClass = '';
  @Input() disabled = false;
  @Input() displayIcon = false;
  @Input() elementIndex = 0;
  @Input() elementType: ElementType = 'button';
  @Input() focusProps: ElementFocus = { active: false };
  @Input() label = '';
  @Input() iconPath = '';
  @Input() id = '';
  @Input() mdChangeWidth = false;
  @Input() role: ButtonRoleType = 'button';
  @Input() size: ButtonSize = 'medium';
  @Input() type: ButtonType = 'primary';
  @Input() fontFamily = false;
  @Input() removeAfterContent = false; // Enable Or Disable Button ::after content

  @Output() notify: EventEmitter<boolean> = new EventEmitter();

  // eslint-disable-next-line complexity
  ngOnChanges() {
    if (this.focusProps && this.idpButton) {
      if (
        !this.focusProps.active &&
        this.idpButton.nativeElement &&
        this.elementIndex === this.focusProps.index
      ) {
        this.idpButton.nativeElement.focus();
      }
    }
  }

  notifyClick() {
    this.notify.emit(true);
  }

  getClasses(): string {
    return `${this.getStyle()} + ' ' + ${this.getFont()}`;
  }

  getFont(): string {
    return this.fontFamily ? 'idp-btn__font-family' : '';
  }

  getStyle(): string {
    return (
      this.customClass +
      ' idp-' +
      this.type +
      ' idp-btn-' +
      this.size +
      (this.type === 'link' && this.iconPath ? ' idp-link__icon' : '') +
      (this.disabled ? ' disabled' : '')
    );
  }
}
